import type { Provider } from '@angular/core';
import { SurfaceType } from '@jms/model';
import { defineSurfaceRuntime, provideSurfaceRuntime } from './core';
import { provideSurface } from './core/runtime/surfaces';
import type { SurfaceRegistration } from './core/runtime/surfaces';
import { WbSurfaceSaveStatusComponent } from './core/surface/wb.surface.save.status.component';
import { agentSurface } from './surfaces/agent/agent.surface.definition';
import { WbSurfaceCreatorHostComponent } from './surfaces/creator';
import { creatorSurface } from './surfaces/creator/creator.surface.definition';
import { formSurface, WbSurfaceFormHostComponent } from './surfaces/form';
import { WbSurfaceFinancialDocumentHostComponent } from './surfaces/financial-document';
import { financialDocumentSurface } from './surfaces/financial-document/financial.document.surface.definition';
import { inboxSurface } from './surfaces/inbox/inbox.surface.definition';
import { WbSurfaceManageHostComponent } from './surfaces/manage';
import { manageSurface } from './surfaces/manage/manage.surface.definition';
import { quickViewSurface } from './surfaces/quick-view/quick.view.surface.definition';
import { WbSurfaceQuickViewHostComponent } from './surfaces/quick-view/wb.surface.quick.view.host.component';
import { WbSurfaceSettingsHostComponent } from './surfaces/settings';
import { settingsSurface } from './surfaces/settings/settings.surface.definition';
import { detailSurface, WbSurfaceDetailHostComponent } from './surfaces/detail';
import { schedulingEditorSurface, WbSurfaceSchedulingEditorHostComponent } from './surfaces/scheduling-editor';
import { workflowEditorSurface, WbSurfaceWorkflowEditorHostComponent } from './surfaces/workflow-editor';

export const WORKBUDDY_SURFACE_REGISTRATIONS = {
  [SurfaceType.Agent]: { definition: agentSurface },
  [SurfaceType.Creator]: { definition: creatorSurface, host: WbSurfaceCreatorHostComponent },
  [SurfaceType.Form]: { definition: formSurface, host: WbSurfaceFormHostComponent },
  [SurfaceType.Inbox]: { definition: inboxSurface },
  [SurfaceType.Manage]: { definition: manageSurface, host: WbSurfaceManageHostComponent },
  [SurfaceType.QuickView]: { definition: quickViewSurface, host: WbSurfaceQuickViewHostComponent },
  [SurfaceType.Settings]: { definition: settingsSurface, host: WbSurfaceSettingsHostComponent },
  [SurfaceType.FinancialDocument]: { definition: financialDocumentSurface, host: WbSurfaceFinancialDocumentHostComponent },
  [SurfaceType.Detail]: { definition: detailSurface, host: WbSurfaceDetailHostComponent },
  [SurfaceType.SchedulingEditor]: { definition: schedulingEditorSurface, host: WbSurfaceSchedulingEditorHostComponent },
  [SurfaceType.WorkflowEditor]: { definition: workflowEditorSurface, host: WbSurfaceWorkflowEditorHostComponent },
} as const satisfies Record<SurfaceType, SurfaceRegistration>;

const workbuddySurfaceChromeRuntime = defineSurfaceRuntime({
  headerSlot: [{ key: 'save-status', component: WbSurfaceSaveStatusComponent }],
});

export function provideWorkBuddySurfaces(): Provider[] {

  return [
    ...provideSurfaceRuntime(workbuddySurfaceChromeRuntime),
    ...Object.values(WORKBUDDY_SURFACE_REGISTRATIONS).map(registration => provideSurface(registration)),
  ];
}
